const HS_PORTAL_ID = '41369222';
const HS_FORM_GUID = '4c4da50f-dbca-4f6b-98be-7ad0655068b1';

let visitorIpAddress;

const isHumanEnough = (formData) => formData.get('soy_un_aparato').length === 0;

const getVisitorIpAddress = () =>
	fetch('https://api.ipify.org').then((res) => res.text());

const sendFormData = (formData) => {
	const fields = formData
		.entries()
		.map(([name, value]) => ({ name, value }))
		.toArray();

	const context = {
		ipAddress: visitorIpAddress,
		pageName: document.title,
		pageUri: document.URL.toString(),
	};

	return fetch(
		`https://api.hsforms.com/submissions/v3/integration/submit/${HS_PORTAL_ID}/${HS_FORM_GUID}`,
		{
			headers: { 'Content-Type': 'application/json' },
			method: 'post',
			body: JSON.stringify({ fields, context }),
		}
	);
};

const showSuccessMessage = (form, message) => {
	const title = document.querySelector('h1');
	const messageEl = document.createElement('div');
	messageEl.classList.add('event-form__message');
	messageEl.innerHTML = message;

	// Replace the title
	title.textContent = 'Thank you';

	// Remove the other elements next to the title
	for (
		let el = title.nextElementSibling;
		el !== null;
		el = el.nextElementSibling
	)
		el.remove();

	// Add the message
	title.insertAdjacentElement('afterend', messageEl);

	// Remove the form
	form.remove();
};

const updateFormState = (form, blocked) => {
	const submitButton = form.querySelector('button[type="submit"]');
	if (blocked) {
		form.style.pointerEvents = 'none';
		submitButton.disabled = true;
		submitButton.textContent = 'Sending...';
		submitButton.style.opacity = '0.75';
	} else {
		form.style.pointerEvents = 'all';
		submitButton.disabled = false;
		submitButton.textContent = 'Submit';
		submitButton.style.opacity = '1';
	}
};

const handleFormSubmit = async (event) => {
	event.preventDefault();

	const form = event.target;
	const formData = new FormData(form);
	if (isHumanEnough(formData)) {
		updateFormState(form, true);

		const response = await (await sendFormData(formData)).json();
		if (response?.inlineMessage) {
			showSuccessMessage(form, response.inlineMessage);
		} else {
			updateFormState(form, false);
		}
	}
};

document.querySelectorAll('.wp-block-occasions-event-form').forEach((form) => {
	form.addEventListener('submit', handleFormSubmit);
});

getVisitorIpAddress().then((ipAddress) => {
	visitorIpAddress = ipAddress;
});
